<template>
    <div>
        <div class="row">
            <div class="col-sm-2">
                <div class="eypr-back-list-table">
                    <b-button :to="{name: 'eyprNarrativeList'}"
                              variant="primary"
                              class="eypr-back-title"
                              block
                    >
                        <fa-icon :icon="['fal','chevron-circle-left']" />
                        To EYPR-Narrative List
                    </b-button>
                </div>
                <br>
                <b-nav pills vertical class="shadow">
                    <b-nav-item
                        v-for="tab in eyprNarrativeTabs"
                        :key="tab.name"
                        class="tab-outline"
                        :active-class="'active tab-outline'"
                        :exact-active-class="'active tab-outline'"
                        exact
                        :to="{
                            ...tab.route,
                            params: {formDisabled, eyprNarrativeId, applicantId: eyprNarrativeApplicantId}
                        }"
                    >
                        <fa-icon
                            v-if="tab.statusIcon"
                            :icon="tab.statusIcon.icon"
                            :class="tab.statusIcon.classes"
                        />
                        {{ tab.description }}
                    </b-nav-item>
                </b-nav>
            </div>
            <div class="col-sm-10">
                <transition name="fade" mode="out-in">
                    <b-card header-class="title-display" no-body>
                        <EyprNarrativeHeader
                            slot="header"
                        />
                        <b-card-body>
                            <router-view :key="$route.fullPath"
                                         @save:eyprNarrative:questions="save"
                            />
                        </b-card-body>
                    </b-card>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
// import { AlertManager } from '$Shared/@arc/vue-arc-alerts';
import { alertManager as AlertManager } from '@/plugins/alertManager';
import { mapGetters, mapActions, mapState } from 'vuex';
import EyprNarrativeHeader from './EyprNarrativeHeader';

export default {
    name: 'EyprNarrative',

    components: {
        EyprNarrativeHeader,
    },

    props: {
        eyprNarrativeId: { type: [String, Number], required: true },
        formDisabled: { type: Boolean, default: false },
    },

    computed: {
        ...mapGetters({
            currentAy: 'ref/global/currentAy',
            isReviewer: 'auth/isReviewer'
        }),

        ...mapState('ref/eyprNarrative', {
            eyprNarrativeModules: 'modules',
        }),

        ...mapState('eyprNarrative/form', {
            eyprNarrativeAcademicYear: 'academic_year',
            eyprNarrativeApplicantId: 'applicant_id',
        }),

        eyprNarrativeTabs() {
            console.log('modules: ', this.eyprNarrativeModules);
            return this.isReviewer
                ? this.eyprNarrativeModules
                : this.eyprNarrativeModules.filter(module => module.name !== 'EyprNarrativeReview');
        },
    },

    async mounted() {
        await this.fetchEyprNarrative({
            eyprNarrativeId: this.eyprNarrativeId,
        });
        this.fetchRefEe(this.eyprNarrativeAcademicYear);
        this.fetchRefEyprNarrative(this.eyprNarrativeAcademicYear);
    },

    methods: {
        ...mapActions({
            fetchRefEe: 'ref/ee/fetchRefEe',
            fetchEyprNarrative: 'eyprNarrative/fetchEyprNarrative',
            fetchRefEyprNarrative: 'ref/eyprNarrative/fetch',
            saveEyprNarrative: 'eyprNarrative/form/save',
        }),

        async save() {
            await this.saveEyprNarrative({
                eyprNarrativeId: this.eyprNarrativeId,
            });

            AlertManager.showSuccess({ message: 'Successfully saved the eyprNarrative.' });
        },
    },
};
</script>

<style lang="scss">
input[type='date'] {
    -moz-appearance: textfield;
}

input[type='date']::-webkit-outer-spin-button,
input[type='date']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.label-title {
    text-align: left;
    font-weight: bold;
}

.eypr-back-list-table .eypr-back-title {
    background: #380064;
    font-size: medium;
    color: white;
    text-decoration: none;
    font-weight: bold;
}


.file-label {
    margin-top: 5px;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
}

.field-title {
    text-align: right;
    font-weight: bold;
}

.attach-title {
    text-align: center;
    margin-top: 2px;
    padding-top: 2px;
}

.table-title {
    font-weight: bold;
    font-size: 20px;
}

.attachment-title {
    font-weight: bold;
    font-size: 18px;
}

.checkbox-title {
    color: black;
}

.checkbox-box:valid,
.checkbox-box[attr='is-valid'] {
    background-color: #28a745;
    border-color: #28a745;
}

.field-contents {
    text-align: left;
}

.notes-label {
    font-size: 16px;
    text-align: left;
    font-weight: bold;
    margin: 0;
    padding: 0;
}

.note-footer {
    font-size: 18px;
}

.fileSelected {
    color: green;
}

.tab-outline {
    font-size: 17px;
    background-color: white;
    border-top: 1px solid #380064;

    &:first-of-type {
        border-top: none;
    }

    &:hover,
    &:focus,
    & :hover,
    & :focus {
        background-color: #e6dfec;
    }

    &.nav-item {
        & a.nav-link {
            padding: 0.5rem 0.25rem 0.5rem 0.75rem;
            color: #380064;
            &.active {
                color: #fafafa;
                background-color: #380064;
            }
        }
    }
}

.nav-item-status-icon {
    margin-top: -0.25rem;
    padding-left: 0.25rem;
    font-size: 1.25em;
    float: right;
}
</style>
